import { REGISTER, LOGIN, KYC } from "./types";

const register = (data, history) => ({
  type: REGISTER.REGISTER,
  payload: data,
  history,
});

const login = (data, history) => ({
  type: LOGIN.LOGIN,
  payload: data,
  history,
});

const updateUser = (data) => ({
  type: LOGIN.UPDATE_USER,
  payload: data,
});

const updateUserSuccess = (data) => ({
  type: LOGIN.UPDATE_USER_SUCCESS,
  payload: data,
});

const logout = (data, history) => ({
  type: LOGIN.LOGOUT,
  payload: data,
  history,
});

const resetPassword = (data, history) => ({
  type: LOGIN.RESET_PASSWORD,
  payload: data,
  history,
});

const setUser = (data) => ({
  type: REGISTER.SETUSER,
  payload: data,
});

const setRegisterError = () => ({
  type: REGISTER.FAIL,
});

const setLoginError = () => ({
  type: LOGIN.FAIL,
});

const getKyc = () => ({
  type: KYC.FETCH,
});

const setKyc = (data) => ({
  type: KYC.SUCCESS,
  payload: data,
});

export {
  register,
  setUser,
  setRegisterError,
  login,
  logout,
  setLoginError,
  getKyc,
  setKyc,
  updateUser,
  resetPassword,
  updateUserSuccess,
};
